import { createContext } from "react";

const ClientStyleContext = createContext({
  reset: () => {},
});

export default ClientStyleContext;
